<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <img src="/img/loading.gif" style="height: 80px; width: 80px" />
    </div>
    <p v-else-if="myPath.total === 0" class="text-muted">
      {{ $t("TRAININGS.MY_PATH_EMPTY") }}
    </p>
    <div v-else class="row">
      <div class="col-lg-6">
        <base-progress
          :type="finished ? 'success' : 'primary'"
          :value="percent"
          :height="8"
          show-label
          :label="
            $t('TRAININGS.MY_PATH_PROGRESS', {
              completed: myPath.completed,
              total: myPath.total,
            })
          "
        />
        <base-alert v-if="finished" type="success" class="mt-3">
          <i class="fa fa-check-circle mr-1"></i>
          {{ $t("TRAININGS.MY_PATH_DONE") }}
        </base-alert>
        <div class="border rounded mt-3">
          <training-files-list
            :files="myPath.files"
            numbered
            @select="open($event)"
          />
        </div>
      </div>
    </div>

    <training-files-modal
      :show="showModal"
      :title="$t('TRAININGS.WELCOME_TITLE')"
      :files="myPath.files"
      :initial-file-id="openedFileId"
      numbered
      @close="showModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TrainingFilesList from "@/components/Trainings/TrainingFilesList.vue";
import TrainingFilesModal from "@/components/Trainings/TrainingFilesModal.vue";

export default {
  name: "training-my-path",

  components: { TrainingFilesList, TrainingFilesModal },

  data() {
    return {
      loading: true,
      showModal: false,
      openedFileId: null,
    };
  },

  computed: {
    ...mapGetters({ myPath: "trainings/myPath" }),
    percent() {
      if (!this.myPath.total) {
        return 0;
      }
      return Math.round((this.myPath.completed / this.myPath.total) * 100);
    },
    finished() {
      return (
        this.myPath.total > 0 && this.myPath.completed === this.myPath.total
      );
    },
  },

  async created() {
    try {
      await this.$store.dispatch("trainings/myPath");
    } catch (error) {
      this.$notify({
        type: "danger",
        message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
      });
    }
    this.loading = false;
  },

  methods: {
    open(file) {
      this.openedFileId = file.id;
      this.showModal = true;
    },
  },
};
</script>
